import React, { useState } from 'react';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import Button from '../../shared/Button';

const Wrapper = styled.div`
  padding: 4px;
`;

const HeaderWrapper = styled.div`
  width: 100%;
  text-align: left;
`;

const BodyWrapper = styled.div`
  text-align: left;
  margin-top: 20px;
`;

export const ModalButtonGroup = styled.div`
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  &&& button {
    margin-bottom: 0;
    pointer-events: auto;
  }
`;

export const AnswerInput = styled.input`
  width: 100%;
  padding: 12px 22px;
  margin: 10px 0;
  border-radius: 8px;
  border: 1px solid;
  border-color: ${themeGet('colors.black.60')};
`;

const ModalConfirmation = ({
  onSave,
  onCancel,
  header,
  body,
  submitText,
  cancelText,
  variant = 'primary',
  mode = 'contained',
  answer = null,
  actionTitle = null,
  cancelVariant = 'grey',
  cancelMode = 'outline',
}) => {
  const { t } = useTranslation('clients');
  const [answerValue, setAnswerValue] = useState('');
  const checkAnswerValue = answerValue !== answer;

  const handleOnClick = () => {
    if (onSave) onSave();
    Swal.close();
  };

  const handleOnCancel = () => {
    if (onCancel) onCancel();
    Swal.close();
  };

  return (
    <Wrapper>
      <HeaderWrapper>
        <Text as="div" variant="h5">
          {header}
        </Text>
      </HeaderWrapper>
      <BodyWrapper>
        <Text as="div" variant="body1" data-cy="modalBody">
          <Trans>{body}</Trans>
        </Text>
      </BodyWrapper>
      {answer && (
        <AnswerInput
          value={answerValue}
          onChange={e => setAnswerValue(e.target.value)}
          placeholder={answer}
          data-cy="answerInput"
        />
      )}
      <ModalButtonGroup>
        <Button
          variant={cancelVariant}
          mode={cancelMode}
          onClick={handleOnCancel}
        >
          {cancelText || t('shared:no')}
        </Button>
        <Button
          ml="16px"
          variant={variant}
          mode={mode}
          type="button"
          onClick={handleOnClick}
          disabled={answer && checkAnswerValue}
          title={checkAnswerValue ? actionTitle : null}
          data-cy="submitButton"
        >
          {submitText || t('shared:yes')}
        </Button>
      </ModalButtonGroup>
    </Wrapper>
  );
};

ModalConfirmation.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  body: PropTypes.string,
  submitText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelText: PropTypes.string,
  variant: PropTypes.string,
  mode: PropTypes.string,
  answer: PropTypes.string,
  actionTitle: PropTypes.string,
  cancelVariant: PropTypes.string,
  cancelMode: PropTypes.string,
};

export default ModalConfirmation;
